import { render, staticRenderFns } from "./RegisterCodeRegistration.vue?vue&type=template&id=527698d2&scoped=true&"
import script from "./RegisterCodeRegistration.vue?vue&type=script&lang=ts&"
export * from "./RegisterCodeRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527698d2",
  null
  
)

export default component.exports